// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".explorer .drawer .visual-viewer{position:relative}.explorer .drawer .visual-viewer__preview img,.explorer .drawer .visual-viewer__preview video{width:100%}\n", ""]);
// Exports
module.exports = exports;
